import React from "react";
import "./mobile.css";
function Mobile({ isOpen, setIsOpen }) {
  return (
    <div className="mobile">
      <div className="close-icon" onClick={() => setIsOpen(!isOpen)}>
        <i className="fi-rr-cross-circle"></i>
      </div>
      <div className="mobile-option">
        <a href="#about">
          <i className="fi fi-rr-user option-icon"></i>About
        </a>
      </div>
      <div className="mobile-option">
        <a href="#experience">
          <i className="fi-rr-briefcase option-icon"></i>Experience
        </a>
      </div>
      <div className="mobile-option">
        <a href="#projects">
          <i className="fi-rr-edit-alt option-icon"></i>Projects
        </a>
      </div>
      <div className="mobile-option">
        <a href="#skills">
          <i className="fi-rr-laptop option-icon"></i>Skills
        </a>
      </div>
      <div className="mobile-option">
        <a href="#competencies">
          <i className="fi fi-rr-bullseye-arrow option-icon"></i>Competencies
        </a>
      </div>
      <div className="mobile-option">
        <a href="#work">
          <i className="fi fi-rr-diploma option-icon"></i>Certificates
        </a>
      </div>
      <div className="mobile-option">
        <a href="#education">
          <i className="fi fi-rr-graduation-cap option-icon"></i>Education
        </a>
      </div>
      <div className="mobile-option">
        <a href="#achievements">
          <i className="fi fi-rr-trophy option-icon"></i>Achievements
        </a>
      </div>
      <div className="mobile-option">
        <a href="#contact">
          <i className="fi fi-rr-envelope option-icon"></i>Contact
        </a>
      </div>
    </div>
  );
}

export default Mobile;
